'use strict';
var Fp = require('fp/app');
const helpers = require('../common/helpers');

module.exports = class navigation extends Fp {
	constructor() {
		super();
		this.config = config;
		this.btnInscriptionNavbar = '[data-nav="btn-inscription"]';
	}

	initialize(config) {
		let self = this;

		/// On clone le btn d'inscription et on le colophon
		this.createCTA('btn-inscription');
		// Sur mobile, on affiche la navbar au début
		document.querySelector(this.btnInscriptionNavbar).hidden = helpers.isTouchDevice() ?false : true;

		/// Au click sur un item du menu, on active l'item, on l'affiche au milieu
		this.setActiveItem(config.links);

		/// Au scroll :
		/// On affiche ou masque la navbar
		/// On set l'item actif
		/// On affiche ou masque le bouton d'inscription
		window.addEventListener('scroll', function () {
			self.scrollEvents(config);
		});
		window.addEventListener('touchmove', function () {
			self.scrollEvents(config);
		});
	}

	/**
	 *
	 * @description : update state active item navbar
	 */
	linkStateEvent(links, sections, navbar) {
		let index = this.navbar.querySelectorAll('.navbar__links').length;

		for (let i = 0; i < index; i++) {
			if (helpers.offset(sections[i]).top < 70) {
				links.forEach((link) => link.parentElement.classList.remove(this.selectors.activeClass));
				links[i].parentElement.classList.add(this.selectors.activeClass);

				let posMiddle = links[i].offsetLeft - links[i].clientWidth / 2;
				if (posMiddle > navbar.querySelector('ul').clientWidth / 2) {
					navbar.querySelector('ul').scrollTo(posMiddle, 0);
				} else {
					navbar.querySelector('ul').scrollTo(0, 0);
				}
			} else {
				links[i].parentElement.classList.remove(this.selectors.activeClass);
			}
		}
	}
	/**
	 * On ajoute une classe sur l'item sur lequel on a cliqué
	 * on la retire à tous les éléments siblings
	 * @param {HTML Collection} links
	 */
	setActiveItem(links) {
		let li = [...links];

		const setActive = el => {
			[...el.parentElement.parentElement.children].forEach(sib => sib.classList.remove(this.selectors.activeClass))

			window.scrollTo({
				behavior: 'smooth',
				top: document.querySelector(`#${el.dataset.scrollTo}`).offsetTop
			})
		}

		li.forEach(el => el.addEventListener('click', e => setActive(e.target)))
	}

	/**
	 * Lorsque l'utilisateur scroll, on appelle cette fonction
	 * elle affiche ou masque la barre de navigation stickée en haut et la barre d'inscription stickée en bas
	 * lorsque l'on arrive sur une section N, elle active l'item N de la barre de navigation
	 * @param {*} config
	 */
	scrollEvents(config) {
		let self = this,
			links = config.links,
			sections = config.sections,
			navbar = config.navbar;

		if (window.scrollY > helpers.offset(document.getElementById('header')).height) {
			navbar.classList.remove(this.selectors.hiddenClass);
		} else {
			navbar.classList.add(this.selectors.hiddenClass)
		}

		self.linkStateEvent(links, sections, navbar);

		let selectorDates = '';
		switch (this.config.codeTypeCircuit) {
			case 10:
				selectorDates = this.config.hasPrix.indiv ? '#liberteDates' : '#sectionDates';
				break;
			case 3:
				selectorDates = this.config.hasPrix.indiv ? '.fp__budget' : '#sectionDates';
				break;
			default:
				selectorDates = this.config.hasPrix.gir ? '.dates__liste' : '#sectionDates';
				break;
		}
		if ((helpers.isTouchDevice() || helpers.offset(document.querySelector('.fp__infosCircuit')).bottom < 105) && (helpers.offset(document.querySelector(selectorDates)).top < -1 * helpers.offset(document.querySelector(selectorDates)).height || helpers.offset(document.querySelector(selectorDates)).top > window.innerHeight)) {
			document.querySelector(this.btnInscriptionNavbar).hidden = false;
		} else {
			document.querySelector(this.btnInscriptionNavbar).hidden = true;
		}
	}

	/**
	 * Ajout dynamique du cta au scroll
	 * @param {string} name
	 */
	createCTA(name) {
		let elem = document.querySelector(`[data-cloned="${name}"]`),
			container = document.querySelector(`[data-nav="${name}"]`);

		// Create a copy of it
		let clone = elem.cloneNode(true);
		if (helpers.getWindowWidth() > 1023) {
			// create a new div element
			const newDiv = document.createElement('div');
			newDiv.classList.add('fp__nomCircuit');
			// and give it some content
			const newContent = document.createTextNode(config.nomCircuit);
			// add the text node to the newly created div
			newDiv.appendChild(newContent);
			container.append(newDiv);
		}

		let note = document.querySelector('.fp__note');
		if (note != null) {
			// Create a copy of it
			let clone = note.cloneNode(true);
			container.append(clone);
		}
		let prix = document.querySelector('.fp__prix');
		if (prix != null) {
			// Create a copy of it
			let clone = prix.cloneNode(true);
			container.append(clone);
		}

		container.append(clone);

		document.querySelector(this.btnInscriptionNavbar).hidden = true;
		container.querySelector('button').textContent = document.querySelector(this.btnInscriptionNavbar).dataset.libelleButton;

		// Pour une demande de devis ou pour les libertés GN & TCA, on redirige au click sur la demande de devis
		if (config.codeTypeCircuit === 3) {
			document.querySelector(`${this.btnInscriptionNavbar} button`).addEventListener('click', (e) => {
				window.location.href = e.target.dataset.url;
			})
		}
		// @TODO
		//Click avis mobile
	}
}